// extracted by mini-css-extract-plugin
export default {"root":"Terms_root__5kxjE","container":"Terms_container__gUyez","header":"Terms_header__nfLu5","terms":"Terms_terms__rj5BR","terms_sep":"Terms_terms_sep__6lWP3"};